<template>
  <div>
    <PageTitleVue 
      :sub-title="subTitle" 
      :key="subTitle"
      :small="pageTitle == 'NOVO UPLOAD' ? true : false"
      > 
      
      {{ pageTitle }}

      <template #action>
        <div>
          <Create 
            v-if="uploadPermission && store.state.componentActive.__name === 'AsosList'"
            :icon="PhCloudArrowUp"
            :label="'Novo upload'"
            :width-medium="true"
            @click="setFormComponentActive"
          />

          <Create 
            v-else-if="(uploadPermission && store.state.componentActive.__name !== 'AsosList')"
            :icon="PhArrowLeft"
            :label="'Ver documentos'"
            :width-medium="true"
            @click="setListComponentActive"
          />
        </div>
      </template>
    </PageTitleVue>
    
    <ListAndForm />

  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import ListAndForm from './layout/BaseListAndFormAso.vue'
import Create from '@/components/Buttons/Create.vue'
import AsosService from './service/asos.service'
import { PhArrowLeft, PhCloudArrowUp } from '@phosphor-icons/vue'
import { onBeforeMount } from 'vue'
import { storeApp } from '@/store'
import { dataAso } from './store'
import { ref } from 'vue'
import { computed } from 'vue'
import { markRaw } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'

const store = dataAso
const subTitle = computed(() => dataAso.getters.getPageSubTitle);

let permissions = localStorage.getItem('__permissions')
let permissionArray = permissions?.split(',');
const uploadPermission = ref(
  permissionArray.includes('docs_upl')
)

const pageTitle = computed(() => {
  if(dataAso.state.componentActive.__name == 'AsosList' && uploadPermission.value) {
    dataAso.dispatch("setPageTitle", "DOCUMENTOS");
    dataAso.dispatch("setPageSubTitle", "Gerencie os documentos de seus funcionários");
  }
  if(dataAso.state.componentActive.__name == 'AsosList' && ! uploadPermission.value) {
    dataAso.dispatch("setPageTitle", "DOCUMENTOS");
    dataAso.dispatch("setPageSubTitle", "Veja todos os documentos que recebeu");
  }
  if(dataAso.state.componentActive.__name != 'AsosList') {
    dataAso.dispatch("setPageTitle", "NOVO UPLOAD");
    dataAso.dispatch("setPageSubTitle", "Faço o upload de novos documentos");
  }

  return dataAso.getters.getTitle
})

onBeforeMount(async () => {
  storeApp.state.loading = true
  setListComponentActive()
  await getDocs()
  Promise.allSettled([
    await getEmployeesByCombo()
  ])
  storeApp.state.loading = false
})

// pega todos os asos
async function getDocs() {
  await AsosService.getAllDocs()
  .then(res => {
    console.log(res.data);
    store.dispatch('setAllDocs', res.data)
  }).catch(err => {
    console.log(err);
  })
}

// pega os nomes dos colaboradores para o combo do form
async function getEmployeesByCombo() {
  await AsosService.getEmployeesByCombo()
  .then(res => {
    store.dispatch('setEmployees', res.data)
  }).catch(err => {
    console.log(err);
  })
}

// altera o component ativo
function setFormComponentActive() {
  if(! uploadPermission.value)
    return toast('Aviso', 'Você não tem permissão para ver essa página', 'info')

  dataAso.dispatch('setFormComponentActive')
}

// altera o component ativo
function setListComponentActive() {
  dataAso.dispatch('setListComponentActive')
}

</script>
